import { actionTypeKeys } from "../actions/actionTypeKeys";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { DeepLink } from "../types/deepLink";

export default function deepLinkReducer(state: DeepLink | null = initialState.deepLink, action: AnyAction) {
  switch (action.type) {
    case actionTypeKeys.SET_DEEP_LINK:
      return { ...action.payload };
    default:
      return state;
  }
}
